import { deauthorize } from '@/entities/Authorization'

const name = 'refreshTokens'

export {
    name,
    deauthorize,
}
